/**
 * Adds or replaces a query parameter on an absolute URL.
 * Missing URLs, missing values, and invalid URLs are returned unchanged.
 */
function appendQueryParamToUrl(
  url: string | undefined,
  paramName: string,
  paramValue: string | undefined,
): string | undefined {
  if (!url || !paramValue) {
    return url;
  }

  let parsedUrl: URL;
  try {
    parsedUrl = new URL(url);
  } catch {
    return url;
  }

  parsedUrl.searchParams.set(paramName, paramValue);
  return parsedUrl.toString();
}

export { appendQueryParamToUrl };
